import { CookieKeys } from '../enums/cookieKeys'

const isStagingToken = (process.env.AUTH_COOKIE_ENV || '') !== 'production'

export const getAccessTokenCookieName = () => {
  return isStagingToken ? CookieKeys.BillyApiAccessTokenStaging : CookieKeys.BillyApiAccessToken
}

export const getExternalTokenCookieName = () => {
  return isStagingToken ? CookieKeys.BillyApiExternalTokenStaging : CookieKeys.BillyApiExternalToken
}
